// 创建文件en/index.js
const en = {
    my: "My",
    today: "Today",
    this_week: "This Week",
    this_month: "This Month",
    last_month: "Last Month",
    this_year: "This Year",
    number_of_people: "Number of People",
    amount: "Amount",
    enter_username_id_to_search: "Enter Username ID to Search",
    team_list: "Team List",
    "Agent.Center": "Agent Center",
    registration_time: "Registration Date",
    selling_face_value: "Selling Face Value",
    click_for_details: "Click for Details",
    "agent_login": "Agent Login",
    'SignOut': 'Delete Account',
    'Contact us': 'Contact us',
    'Download our app': 'Download our app',
    'Download it from': 'Download it from',
    'About Us': 'About Us',
    'Gobuy USA was founded in 2012': 'Gobuy USA was founded in 2021',
    'Customer service': 'Customer service',
    'frequently asked question': 'frequently asked question',
    'Return and exchange policy': 'Return and exchange policy',
    'Shipping and distribution': 'Shipping and distribution',
    'Contact us by email': 'Contact us by email',
    'Privacy Policy and Terms of Use': 'Privacy Policy and Terms of Use',
    'Privacy Policy': 'Privacy Policy',
    'Terms of use': 'Terms of use',
    'Upload credentials': 'Upload credentials',
    'The withdrawal is being processed': 'The withdrawal is being processed',
    'Cause of failure': 'Cause of failure',
    'Your shopping cart is still empty': 'Your shopping cart is still empty',
    'Log in to view the items in your cart': 'Log in to view the items in your cart',
    'Browse around': 'Browse around',
    'Account correlation': 'Account correlation',
    'Order management': 'Order management',
    'Payment method': 'Payment method',
    'Collection address': 'Collection address',
    'Gobuy GIFT CARD': 'Gobuy GIFT CARD',
    'High Priced Recycling': 'High Priced Recycling',
    'Data': 'Data',
    'congratulations': 'congratulations',
    'Obtain': 'Obtain',
    'ThankYouForParticipating': 'Thank You for Participating',

    // navbar
    Home: 'Home',
    Category: 'Category',
    Search: 'Search',
    ShoppingCart: 'Shopping Cart',
    Mine: 'Mine',

    "MyCommission": "My Commission",
    "Gross income": "Gross income",
    "Direct commission": "Direct commission",
    "Indirect commission": "Indirect commission",
    "Transfer to wallet": "Transfer to wallet",
    "Tip: The transfer amount must be greater than 10USDT": "Tip: The transfer amount must be greater than 10USDT",
    "transfer": "transfer",
    "commission": "commission",
    "Please enter": "Please enter",
    "Team Commission": "Team Commission",

    // 首页
    // 搜索
    EnterSearchContent: 'Enter search content',
    'Recent searches': 'Recent searches',
    'popular searches': 'popular searches',
    'Please search': 'Please enter the keyword you want to search',
    'orderSearch': 'Enter the name of the order or product to search',

    // 语言
    'Language selection': 'Language selection',

    // menu
    Brand: 'Brand',
    Collect: 'Collect',
    Manage: 'Manage',
    Order: 'Order',
    Wallet: 'Wallet',
    BlindBox: 'Blind box',
    MenuGiftCard: 'Gift card',
    // HotSale
    HotSale: 'The latest news is in hot sale...',
    // tabs
    TodaysOffer: "Platform Preferred",
    'Phone': "Phone",
    'Smart Watch': "Smart Watch",
    'Smart bracelet': "Smart bracelet",

    // gobuy
    'home.gobuy.title': 'Meet a big surprise',
    'home.gobuy.periods': 'Blind Box Round',
    'home.gobuy.freeze': 'Join the countdown',
    'home.gobuy.drawing': 'Start the countdown',
    'home.gobuy.buy': 'Participate in',
    'home.gobuy.isbuy': 'Participated',
    'home.gobuy.jackpot': 'Bonus pool',
    Purse: 'Purse',
    Box: 'Box',
    'GetAPrize': 'Get a prize',
    Discount: 'Discount',
    when: 'when',
    points: 'points',
    seconds: 'seconds',
    // MessageBox
    'MessageBox.Tips': 'Tips',
    'MessageBox.Confirm': 'Confirm',
    'MessageBox.Cancel': 'Cancel',
    'MessageBox.buy.box': 'Are you sure to buy this blind box?',
    // Toast
    'succ': 'Success',
    'err': 'Error',
    'box.succeeds': 'purchase succeeds',
    'box.frozen': 'Already Participated',
    'box.issue': 'You can only buy one blind box per issue',

    // 商品列表
    filter: 'Filter',
    sales: 'Sales',
    selfOP: 'Self-operated',
    noMore: 'No more',
    brand: 'Brand',
    confirm: 'Confirm',
    reset: 'Reset',
    ComSor: 'Comprehensive Sorting',
    MostPop: 'Most Popular',
    HighLow: 'Price High to Low',
    LowHigh: 'Price Low to High',
    SalVol: 'Sales Volume',
    NewArr: 'New Arrivals',

    // 购物车
    'cart.cart': 'Shopping Cart',
    'cart.edit': 'Edit',
    'cart.done': 'Done',
    'home.cart.voucher': 'Get Coupons',
    'home.cart.outstock': 'Out of Stock',
    'home.cart.offshelf': 'Off the Shelf',
    'Only': 'Only',
    'left': 'left',
    'Promotion': 'Promotion',
    'cart.all': 'Select All',
    'cart.total': 'Total',
    'cart.delete': 'Delete',
    'cart.checkout': 'Checkout',

    // 我的
    'Direct': 'Direct',
    'Indirect': 'Indirect',
    'MyOrders': 'My Orders',
    'ViewAll': 'View All',
    'Unpaid': 'Unpaid',
    'ToShip': 'To Ship',
    'ToReceive': 'To Receive',
    'ToReview': 'To Review',
    // 盲盒
    'MyBlindBox': 'Blind Box List',
    'WaitingDraw': 'Waiting for Draw',
    'Opened': 'Opened (Pick Up/Return)',
    // 礼品卡
    'After sale': 'After sale',
    'GiftCard': 'Gift Card List',
    'RecycleGiftCard': 'Recycle Gift',
    'Verifying': 'Under Verification',
    'Rebuying': 'Buyback in Progress',
    'Repurchased': 'Pending Payment',
    'Paid': 'Payment Made',
    // 常用工具
    'CommonTools': 'Common Tools',
    'MyWallet': 'My Wallet',
    'VirtualOrders': 'Virtual Orders',
    'Refunds': 'Refunds',
    'MyFriends': 'My Friends',
    'ChatList': 'Chat List',
    'RealNameVerification': 'Real Name Verification',
    'MyFavorites': 'My Favorites',
    'Addresses': 'Addresses',
    'MyReviews': 'My Reviews',
    'BrowsingHistory': 'Browsing',
    'Promotions': 'Promotions',
    'StoreManagement': 'Store Management',
    'BecomeASeller': 'Become a Seller',

    // order list
    'SearchPlaceholder': 'Enter Order Item Name to Search',
    OrderNo: 'Order No.',
    items: 'items',
    ShippingFee: 'Shipping Fee',
    'Refund in Progress': 'Refund in Progress',
    'Cancel Order': 'Cancel Order',
    'Refund': 'Refund',
    'Track Shipping': 'Track Shipping',
    'Confirm Receipt': 'Confirm Receipt',
    'Evaluate': 'Evaluate',
    'Delete': 'Delete',
    'Pay': 'Pay',
    'MessageBox.delete.order': 'Are you sure you want to delete this order?',
    'MessageBox.cancel.order': 'Are you sure you want to cancel this order?',
    'MessageBox.receive.order': 'Has this order been received?',
    // detail
    'Order Details': 'Order Details',
    'Pickup Code': 'Pickup Code',
    'Complaint': 'Complaint',
    'After-Sales': 'After-Sales',
    'Gift': 'Gift',
    'Order Date': 'Order Date',
    'Used voucher worth': 'Used voucher worth',
    'CNY': 'CNY',
    'Payment Method': 'Payment Method',
    'Total Product Amount': 'Total Product Amount',
    'Shipping Fee': 'Shipping Fee',
    'Amount Paid': 'Amount Paid',
    'Return': 'Return',
    // 盲盒list
    'Pending Draw': 'Pending Draw',
    'Pending Unboxing': 'Pending Unboxing',
    'Unboxed': 'Unboxed',
    'Collected': 'Collected',
    'Recycled': 'Recycled',
    'Unknown': 'Unknown',
    'Claim': 'Claim',
    'Recycle': 'Buyback',
    'Unbox': 'Unbox',
    'MessageBox.recycle.box': 'Are you sure you want to recycle this mystery box?',
    // 盲盒detail
    'Mystery Box Details': 'Mystery Box Details',
    'Unopened': 'Unopened',
    'box.opened': 'Unopened',
    'Claimed': 'Claimed',
    'Confirm Claim': 'Confirm Claim',
    'MessageBox.pick.box': 'Are you sure you want to pick up this blind box?',
    // 盲盒提货
    'Please add address': 'Please add address',
    // 礼品卡list
    'Face Value Total': 'Face Value Total',
    // 礼品卡detail
    'Gift Card Details': 'Gift Card Details',
    'Card number': 'Card number',
    'Activation code': 'Activation code',
    'Actual recovery price': 'Actual recovery price',
    // 礼品卡回收
    'Gift Card Recycling': 'Gift Card Recycling',
    'Confirm Recycling': 'Confirm Recycling',
    'Please enter the card number': 'Please enter the card number',
    'Please enter the activation code': 'Please enter the activation code',
    'MessageBox.recycle.gift': 'Are you sure you want to recycle this gift card?',

    // 我的钱包
    'My Wallet': 'My Wallet',
    'Available Balance': 'Available Balance',
    'Gift Balance': "Gift Balance",
    'All': "All",
    'Next event loading': "Next event loading",
    'Frozen Funds': 'Frozen Funds',
    'Recharge': 'Top-up',
    "can": "Can",
    'Withdraw': 'Withdraw',
    'Withdrawal Accounts': 'Withdrawal Accounts',
    // 充值
    'Recharge Details': 'Recharge Details',
    'Recharge Order No.': 'Recharge Order No.',
    'Recharge Amount': 'Recharge Amount',
    'Creation Time': 'Creation Time',
    'MessageBox.recharge.pop': 'Please enter the recharge amount',
    // 付款
    'payment': 'payment',
    'Order submitted successfully, please select payment method': 'Order submitted successfully, please select payment method',
    'Rechargeable card': 'Rechargeable card',
    'Please enter a hash': 'Please enter a hash',
    'Immediate payment': 'Immediate payment',
    'Wait for the file to load': 'Wait for the file to load',
    // 提现
    'Withdrawal Details': 'Withdrawal Details',
    'Withdrawal Amount': 'Withdrawal Amount',
    'Application Time': 'Application Time',
    'New Application': 'New Application',
    'Payment Password': 'Payment Password',
    'New Payment Password': 'New Payment Password',
    'Recipient Information': 'Recipient Information',
    'Submit': 'Submit',
    'Add Recipient Account First': 'Add Recipient Account First',
    'Please bind your mobile phone or email first': 'Please bind your mobile phone or email first',
    // 设置
    'Account Settings': 'Account Settings',
    'Change Login Password': 'Change Login Password',
    'Change Payment Password': 'Change Payment Password',
    'Log Out': 'Log Out',
    'Mobile': 'Mobile',
    'Verification Code': 'Verification Code',
    'Email': 'Email',
    'Old Password': 'Old Password',
    'New Password': 'New Password',
    'Confirm Password': 'Confirm Password',
    'Modify': 'Modify',
    'Bind': 'Bind',
    ' Mobile': ' Mobile',
    ' Email': ' Email',
    // 资金详情
    'Fund Details': 'Record History',
    // 提现账号
    'Withdrawal Account': 'Withdrawal Account',
    'Account Type': 'Account Type',
    'USDT Address (opBNB)': 'USDT-opBNB',
    'Edit': 'Edit',
    'Add New': 'Add New',
    'MessageBox.delete.bank': 'Are you sure you want to delete this withdrawal account?',

    // Login
    Login: 'Login',
    'Sign Up': 'Sign Up',
    'Normal Login': 'Normal Login',
    'Username / Email / Phone Number': 'Username / Email',
    'Enter Phone Number': 'Enter Phone Number',
    'Enter Email': 'Enter Email',
    'Enter SMS Code': 'Enter SMS Code',
    'Enter Password': 'Enter Password',
    "enter_login_password_for_verification": "Please enter your login password for verification",
    'Forgot Password': 'Forgot Password',
    'Third-party Login': 'Third-party Login',
    'Please complete the form': 'Please complete the form',
    'WeChat': 'WeChat',
    'Weibo': 'Weibo',
    'QQ': 'QQ',
    'phone login': 'phone login',
    'Login Expired': 'Login Expired',
    'Please enter your phone number first': 'Please enter your phone number first',
    'Please enter your username/email/phone number': 'Please enter your username/email',
    'Please enter your password': 'Please enter your password',
    'Password must be at least 6 characters': 'Password must be at least 6 characters',
    'Please enter an 11-digit phone number': 'Please enter an 11-digit phone number',
    'Please wait for the file to finish loading': 'Please wait for the file to finish loading',
    'send': 'send',
    'signUpTips': 'Your personal data will be used to support your experience throughout the site, to manage access to your account, and for other purposes described in our privacy policy.',
    'Referrer': 'Referrer',
    'Invitation code': 'Invitation code',
    'Please.enter.Invitation.code': 'Please enter the invitation code',
    'Email.verification.code': 'Email verification code',
    'Invite friends': 'Invite Friends',
    'Username': 'Username',
    'Full Name': 'Real name',
    'Set Password': 'Set Password',
    'Change password': 'Change password',
    'Phone Number': 'Phone Number',
    'Username: 3-25 chars, letters & numbers': 'Username: 3-25 chars, letters & numbers',
    '6-20 digits/letters/symbols': '6-20 digits/letters/symbols',
    'By clicking sign up, you agree to': 'By clicking sign up, you agree to',
    'User Agreement': 'User Agreement',
    'Please check the user agreement': 'Please check the user agreement',
    'Please enter a username with 3-25 characters': 'Please enter a username with 3-25 characters',
    'Enter SMS Verification Code': 'Enter SMS Verification Code',
    'Please enter your phone number': 'Please enter your phone number',
    'Please enter the verification code': 'Please enter the verification code',
    'Please enter a 6-digit verification code': 'Please enter a 6-digit verification code',
    'Please enter a password with 6-20 characters': 'Please enter a password with 6-20 characters',
    'Please enter the confirm password': 'Please enter the confirm password',
    'The confirm password does not match the entered password': 'The confirm password does not match the entered password',
    // Password Recovery
    'Password Recovery': 'Password Recovery',
    'Forget.email.tips': 'If your account has not yet been linked to a email number, please contact the platform administrator to recover your password.',

    // Notification 通知消息
    'Notification Message': 'Notification Message',
    'Direct Message': 'Direct Message',
    'System Message': 'System Message',
    'Leave a Message': 'Leave a Message',

    // Delivery address 配送地址
    'Delivery Address': 'Delivery Address',
    'The store is no longer valid, please edit the delivery address again': 'The store is no longer valid, please edit the delivery address again',
    'Default address': 'Default address',
    'Add address': 'Add address',
    'Edit address': 'Edit address',
    'MessageBox.delete.address': 'Are you sure you want to delete this address?',
    'name': 'name',
    'phone': 'phone',
    'district': 'district',
    'address': 'address',
    'default address': 'default address',
    'save and use': 'save and use',
    'save': 'save',
    'Please select a region': 'Please select a region',
    'Please fill in the recipient name': 'Please fill in the recipient name',
    'Name must be 2-15 characters': 'Name must be 2-15 characters',
    'Please fill in the mobile phone number': 'Please fill in the mobile phone number',
    'Please select your location': 'Please select your location',
    'Please fill in the detailed address': 'Please fill in the detailed address',

    //Browsing history 浏览历史
    'Browsing History': 'Browsing History',
    'Clear browsing history': 'Clear History',

    // inviter 推广会员
    'Promotion member': 'Promotion member',
    "PromotionPoster": "Promotion Poster",
    "MemberName": "Member Name",
    "MyAssets": "My Assets",
    "DistributedAmount": "Distributed Amount",
    "NumberOfDistributedProducts": "Distributed Products",
    "DistributedProductAmount": "Distributed Amount",
    "MyTeam": "My Team",
    "LevelOneMembers": "Level 1 Members",
    "LevelTwoMembers": "Level 2 Members",
    "PromotionPoster": "Promotion Poster",
    "PromotionMembers": "Promotion Members",
    "PromotionPerformance": "Promotion Performance",
    "ViewPromotionLink": "Click to View Promotion Link",
    "PromoteViaWeChatQRCode": "Promote via WeChat QR Code",
    "Copy": "Copy",
    "BrowserNotSupportedCopyManually": "Your browser does not support direct copying; please copy manually",
    'GiftCardRecoveryTotal': 'Gift Card Recovery Total',
    'TodaysGiftCardRecoveryCount': 'Today\'s Gift Card Recovery Count',
    'RegistrationDate': 'Registration Date',
    'LastLogin': 'Last Login',
    'Promotion Commission': 'Promotion Commission',

    // userinfo 个人信息
    'Personal Info': 'Personal Info',
    Nickname: 'Nickname',
    Birthdate: 'Birthdate',
    Save: 'Save',
    CropImage: 'Crop Image',
    UseImage: 'Use Image',

    // goodsDetail 商品详情
    Off: 'Off',
    Sold: 'Sold',
    Product: 'Product',
    Comment: 'Comment',
    Details: 'Details',
    ReportViolation: 'Report',
    Cart: 'Cart',
    ChatMessages: 'Chat Messages',
    MyShop: 'My Shop',
    MerchantLogin: 'Merchant Login',
    Share: 'Share',
    ShareTo: 'Share To',
    Poster: 'Poster',
    Follow: 'Follow',
    Unfollow: 'Unfollow',
    PleaseSelectQuantityAndCategory: 'Please select the quantity and category.',
    SelectedWithQuantity1: 'Selected {specification}, quantity {number}.',
    SelectedQuantity1: 'Selected quantity {number}.',
    SelectedWithQuantity2: 'Selected {specification}, quantity {number}.',
    'Add to cart': 'Add to basket',
    'Buy now': 'Buy now',
    Stock: 'Stock ',
    Pieces: ' pieces',
    Quantity: 'Quantity ',
    All: 'All',
    Good: 'Good Review',
    Medium: 'Medium Review',
    Bad: 'Bad Review',
    // 评论
    'Product review': 'Product review',
    anonymous: 'Anonymous',
    noReviewInfo: 'No review information provided',
    'Shop Owners Response': 'Shop Owner\'s Response',
    'This product has no current reviews': 'This product has no current reviews',
    'Product details': 'Product details',
    shop: 'Shop',
    customerService: 'Customer Service',
    shoppingCart: 'Shopping Basket',
    addToCart: 'Add to Basket',
    buyNow: 'Buy Now',
    outOfStock: 'The selected product is currently out of stock, we apologise!',
    notAvailable: 'The selected product is no longer available, we apologise!',
    'Store order message': 'Store order message',
    'Confirm the order': 'Confirm the order',
    productAmount: 'Product Amount',
    discount: 'Discount',
    shippingFee: 'Shipping Fee',
    subtotal: 'Subtotal for Store',
    'Submit an order': 'Submit an order',
    // 退货
    refundAdd: 'Add Refund',
    back: 'Back',
    proofOfRefund: 'Proof of Refund',
    use: 'Use',
    // 一元购
    "yi1": `One Pound Purchase`,
    "yi2": `Price Zone`,
    "yi3": `Zone`,
    "yi4": `Purchase Records`,
    "yi5": `Records of Obtained Products`,
    "yi6": `View Redemption Code`,
    "yi7": `Apply for Withdrawal`,
    "yi8": `Recharge`,
    "yi9": `Participated Quantity`,
    "yi10": `Total Quantity`,
    "yi11": `Shortfall Quantity`,
    "yi12": `Buy Now`,
    "yi13": `Continue Buying`,
    "yi14": `Other Zones`,
    "yi15": `Load More`,
    "yi16": `Coming Soon...`,
    "yi17": `Zone`,
    "yi18": `Round`,
    "yi19": `Period`,
    "yi20": `Price: `,
    "yi21": `Load More`,
    "yi22": `Quick Payment -- Information About the Product You Want to Buy`,
    "yi23": `Quantity to Purchase`,
    "yi24": `(The more you buy, the greater your chances of obtaining the product!)`,
    "yi25": `Total: `,
    "yi26": `Payment Successful`,
    "yi27": `Payment Failed`,
    "yi28": `Reason: `,
    "yi29": `Results Revealed`,
    "yi30": `Lucky Code`,
    "yi31": `Product Winner`,
    "yi32": `Congratulations, You Won This Product`,
    "yi33": `Reveal Time: `,
    "yi34": `Purchase Time: `,
    "yi35": `Total Number Purchased by the Winner: `,
    "yi36": ` Purchase Code:`,
    "yi37": `Pickup`,
    "yi38": `Cash in`,
    "yi39": `Pre-order`,
    "yi40": `Buy`,
    "yi41": `Records of Obtained Products`,
    "yi42": `Winning Date: `,

    "hunt1": `Exchange`,
    "hunt2": `Lucky Head Start`,
    "hunt3": `Unstoppable`,
    "hunt4": `Redemption Code`,
    "hunt5": `Redemption Code: `,
    "hunt6": `Load More`,
    "hunt7": `I Want to Pickup`,
    "hunt8": `Please Enter Redemption Code`,
    "hunt9": `Redemption Price is 10% Off the Sale Price`,
    "hunt10": `Product List`,
    "hunt11": `Zone`,
    "hunt12": `Language`,
    "hunt13": `Announcement`,
    "hunt14": `Navigation`,
    "hunt15": `Official Announcement`,
    "hunt16": `Treasure Records`,
    "hunt17": `Shipping Rules`,
    "hunt18": `Rules Explanation`,
    "hunt19": `I Want to Redeem`,
    "hunt20": `Contact Us`,
    "hunt21": `Email`,
    "hunt22": `Lottery Rules`,
    "hunt23": `Rules Overview`,
    "hunt24": `1. Number Allocation: `,
    "hunt25": `For every 0.1 USDT paid, users get one lucky number starting from 000001 and distributed sequentially until the target number of participants is reached (e.g., 1000).`,
    "hunt26": `2. Lottery Conditions: `,
    "hunt27": `When the product reaches the target number of participants (e.g., 1000), the lottery process begins.`,
    "hunt28": `3. Lottery Time: `,
    "hunt29": `After the last order confirmation, wait for the nearest blockchain time ending in 05, 10, 15, 25, 30, 35, 40, 45, 50, 55, or a full hour.`,
    "hunt30": `4. Winning Number Calculation: `,
    "hunt31": `1. Extract pure numbers from the block hash and calculate the modulo based on the total participants:
                Winning Number = (Pure Numbers from Hash % Total Participants) + 1`,
    "hunt32": `2. The calculated result corresponds to the winning number.`,
    "hunt33": `Participation Stage`,
    "hunt34": `Users gain one lucky number for every 0.1 USDT paid.`,
    "hunt35": `When the product reaches the target number of participants, new entries are stopped.`,
    "hunt36": `Lottery Stage`,
    "hunt37": `Record the exact time of the last order (e.g., 15:47:23).`,
    "hunt38": `Wait for the nearest blockchain block to generate with an appropriate time ending:`,
    "hunt39": `Blockchain time ending in 05, 10, 15, 25, 30, 35, 40, 45, 50, 55, or on the hour (e.g., 15:50:00).`,
    "hunt40": `Fetch the block hash matching the conditions.`,
    "hunt41": `Winning Stage`,
    "hunt42": `Extract pure numbers from the block hash.`,
    "hunt43": `Example block hash: 0000000000000000000a16b6f44536e521000000adbcf3f4b2ec018ffabcd123`,
    "hunt44": `Extracted pure numbers: 16644536521000000342018123`,
    "hunt45": `Modulo Total Participants: `,
    "hunt46": `Winning Number`,
    "hunt47": `= (Extracted Number % Total Participants) + 1 `,
    "hunt48": `If the extracted number is 16644536521000000342018123, and the total participants are 1000: `,
    "hunt49": `= (16644536521000000342018123 % 1000) + 1 = 123 + 1 = 124`,
    "hunt50": `Publicise Results`,
    "hunt51": `The platform announces the winning number and the corresponding user information.`,
    "hunt52": `Also provides the full calculation process (order time, used block hash, extracted numbers, and winning number calculation formula).`,
    "hunt53": `Advantages`,
    "hunt54": `1. Fairness`,
    "hunt55": `Using public blockchain hash values ensures the lottery results are unpredictable and tamper-proof.`,
    "hunt56": `2. Transparency`,
    "hunt57": `Users can verify the hash values and number allocation process.`,
    "hunt58": `3. High Efficiency`,
    "hunt59": `Results can be determined quickly by waiting for the appropriate block.`,
    "hunt60": `Announcement Details`,
    "hunt61": `Purchase Amount: `,
    "hunt62": `Items`,
    "hunt63": `Click for Purchase Codes`,
    "hunt64": `Purchase Code: `,
    "hunt65": `Rules Explanation`,
    "hunt66": `About Orders`,
    "hunt67": `To ensure you receive your products promptly, orders placed before 4 PM will be shipped the same day using XX Courier or XX Courier. For expedited shipping, contact customer service to pay the price difference for XX Courier. Other courier services are currently not supported.`,
    "hunt68": `About Invoices`,
    "hunt69": `All products sold can be issued with electronic invoices. You can contact customer service through your order and provide the invoice information. In general, invoices will be issued within 1-3 days. If it’s during holidays, issuance will be postponed accordingly.`,
    "hunt70": `LuckyBuy`,

    "new1": "Example",
    "new2": "The product requires 1,000 participants. The final order time is 15:47:23.\nThe most recent block time matching the draw time is 15:50:00",
    "new3": "The block hash value is:",
    "new4": "Extracting the pure digits from the hash value:",
    "new5": "Calculating the winning number:",
    "new6": "Winning number",
    "new7": "The winning number is 124, and the corresponding user is the winner.",
    "new8": `Redeemed`,
    "new9": `Not Redeemed`,
    "new10": `Unfortunately, you did not win`,
    "new11": `Congratulations`,
    "new12": `Won the item in this round`,
    "new13": `Redeem`,

    "new14": `Lucky Purchase`,
    "new15": `Item Picked Up`,

    "new16": "Are you sure you want to pick up the goods?",
    "new17": "Are you sure you want to redeem?",
    "copyS": "Copy successful",
    "copyE": "Copy failed",
    "new18": "Product Display",
    "new19": "Previous Page",
    "new20": "Next Page",
    "new21": "To",
    "new22": "Page",
    "new23": "Confirm",
    "new24": "Waiting for the draw",

    "tool1": "Home",
    "tool2": "Products",
    "tool3": "News",
    "tool4": "Hunt Logs",
    "tool5": "Shipping",
    "tool6": "Rules",
    "tool7": "Redeem",
    "tool8": "Contact",
    
    "new25": "Product Redemption",
    "new26": "Please enter your gobuy username",

    "ship1": `Scope of Application`,
    "ship2": `These shipping rules apply to all orders on the luckybuy e-commerce platform. Since the platform only accepts USDT payment, it does not support credit card, cash payment, or freight deduction. The following rules are hereby formulated.`,
    "ship3": `1. Shipping Rules within the United States`,
    "ship4": `Payment Methods`,
    "ship5": `Only USDT payment is accepted. Credit card and cash settlement are not supported.`,
    "ship6": `Cash on Delivery Service`,
    "ship7": `Cash on delivery service is only available for customers within the United States. Prepayment of shipping costs is not required.`,
    "ship8": `Shipping Policy`,
    "ship9": `The order amount does not include shipping costs, which must be paid separately.`,
    "ship10": `Delivery Range`,
    "ship11": `Delivery is supported across the entire mainland United States.`,
    "ship12": `Customer Notice`,
    "ship13": `After placing an order, customers must ensure that their contact information is accurate. The goods need to be signed for by the customer or an authorised representative at the time of receipt.`,
    "ship14": `2. Shipping Rules Outside the United States`,
    "ship15": `Only USDT payment is accepted. Credit card and cash settlement are not supported.`,
    "ship16": `Customers outside the United States must make an additional payment for shipping costs after completing the order payment.`,
    "ship17": `Once the additional shipping payment is made, the platform will arrange shipment.`,
    "ship18": `Cash on Delivery Policy`,
    "ship19": `Cash on delivery service is not provided. Customers outside the United States must complete the payment for shipping costs before the order is processed.`,
    "ship20": `Process for Additional Shipping Costs`,
    "ship21": `After the order is placed, the platform will calculate the shipping costs based on the customer’s address and notify the customer to pay the additional amount via USDT.`,
    "ship22": `Once the payment for shipping is completed, the platform will arrange shipment and provide logistics tracking information.`,
    "ship23": `Delivery is supported to all countries worldwide. The specific delivery time depends on the local logistics conditions.`,
    "ship24": `Customers must ensure that the address and contact information are accurate. Any delivery failures due to incorrect information will be the customer’s responsibility.`,
    "ship25": `The platform is not responsible for customs policies in the destination country. Customers must understand and handle customs clearance and any potential additional fees themselves.`,
    "ship26": `Notes`,
    "ship27": `1.Once an order is successfully paid for, it cannot be cancelled or refunded. Customers are advised to carefully confirm the order information before payment.`,
    "ship28": `2.luckybuy is not responsible for issues arising from force majeure during transportation (such as natural disasters or policy changes) but will make every effort to assist customers in resolving them.`,
    "ship29": `3.For any inquiries, please contact our platform's customer service channels.`,
    "ship30": `Thank you for your understanding and support!`,
    "ship31": `luckybuy is dedicated to serving you.`,

    // 礼品卡相关
    'Original Price':'Original Price',
    'Actual Payment':'Actual Payment',
    'Balance':'Balance',
    'MessageBox.buy.card': 'Are you sure to purchase this gift card?',
    'MyCard':'My Card',
    'Please upload pictures':'Please upload pictures',
    'Share audit list':'Share audit list',
    'Share page':'Share page',
    'Audit result':'Audit result',
    'Share to the community':'Share to the community',
    'imshares1':'Step introduction',
    'imshares2':'Step 1：Share the product on social media,',
    'imshares3':"Step 2：Take a screenshot of the product's shared page and upload it to GoBuy.",
    'Share Time':'Share Time',
    'Audit status':'Audit status',
    'Reason for failure':'Reason for failure',
    'Pending approval':'Pending approval',
    'Approved':'Approved',
    'Audit failed':'Audit failed',
    'Url Copied': 'Link copied successfully, about to redirect to share...',
    'Points Logs': 'Points Logs',
    'My Points': 'My Points',
    'Go Excharge': 'Go to exchange',
    'Confirm points excharge': 'Are you sure you want to convert all points into balance?',
    'is not share': 'You have not completed the sharing task yet',
    'is buied': 'You have already made a purchase today',
    'My card': 'My card',
    "Country/Region": "Country/Region",
    "Contact info": "Contact info",
    "Please enter realname": "Please enter real name",
    "Please enter Phone Number": "Please enter Phone Number",
    "Please enter State/Province/Region": "Please enter State/Province/Region",
    "Please enter City": "Please enter City",
    "Please enter Street Address": "Please enter Street Address",
    "Please enter Postal Code": "Please enter Postal Code",
    "lucky_draw_winning_products": "Lucky buy draw winning products",
    "refundDescription": 'Refund Description', // 退款描述
    "productQualityIssue": 'Product Quality Issue', // 产品质量问题
    "logisticsTransportIssue": 'Logistics and Transport Issue', // 物流与运输问题
    "sellerPlatformIssue": 'Seller or Platform Issue', // 商家或平台问题
    "personalReason": 'Personal Reason', // 个人原因
    "otherSpecialCases": 'Other Special Cases', // 其他特殊情况
    "hunt points rule": "Points description",
    "hunt points rule1": "1. Points acquisition: Users participating in lucky purchases can earn 1 point for every 0.1 US dollars invested.",
    "hunt points rule2": "2. Points redemption: 1 point = 0.01% US dollars",
    'Login Password': "Login password",
    "Level": "Level",
    //新手指南
    "guide.Rewards": "Rewards Introduction",
    "guide.title": "Beginner's Guide",
    "guide.Invitation.Reward": "Event Reward",
    "guide.Order.Sharing": "Order Sharing",
    "guide.section1.title": "Lucky Purchase Guide",
    "guide.section1.step1": "Choose Purchase: Enter the USD zone and select your desired item.",
    "guide.section1.step2": "Choose Quantity: Enter the number of shares you want to participate in.",
    "guide.section1.step3": "Purchase quantity: Only $0.1 is needed to buy 1 unit.",
    "guide.section1.step4": "Wait for the draw: The system will automatically select the lucky winner.",
    "guide.section2.title": "Blind Box Purchase Guide",
    "guide.section2.step1": "Open Blind Box: Click to enter the blind box zone.",
    "guide.section2.step2": "Join Now: Pay 1 USD.",
    "guide.section2.step3": "Reveal Prize: Win prizes worth up to 3 million USD.",
    "guide.section3.title": "Gift Card Purchase Guide",
    "guide.section3.step1": "Share Community: Share the event immediately and upload information.",
    "guide.section3.step2": "Choose Denomination: Freely select gift card price.",
    "guide.section3.step3": "Buy 100 gift cards for only $98.",
    "guide.section3.step4": "Instant buyback: 100% buyback, earn $2",
    "guide.tip.title": "Warm Tip: Don't Miss Out on Great Benefits",
    "guide.tip.luckyBuy": "Participate with only 0.1 USD for a chance to win prizes from 1 USD to 50,000 USD!",
    "guide.tip.luckyBuy1": "Team Commission Reward: Invite friends to buy and enjoy up to 0.2% commission!",
    "guide.tip.luckyBuy2": "Points Redemption: Earn 1 point for each lucky purchase, 1000 points = 0.1 USD!",
    "guide.tip.example": "Example:",
    "guide.tip.example1": "You invite user A, A buys 1000 USD → You get 2 USD commission.",
    "guide.tip.example11": "A invites user B, B buys 1000 USD → You get another 1 USD commission.",
    "guide.tip.boxTitle": "Blind Box Lottery",
    "guide.tip.box": "Participate once with 1 USD, prizes worth up to 3 million USD!",
    "guide.tip.cardTitle": "Gift Card",
    "guide.tip.card": "Team Commission: Invite friends to buy and enjoy up to 0.4% commission!",
    "guide.tip.example2": "When you invite User A to buy a $100 gift card, you will earn $0.4 in commission.",
    "guide.tip.example3": "When A invites User B and B buys a $100 gift card, you’ll earn another $0.2 in commission.",
    "guide.tip.callToAction": "Join now and start your lucky journey!",
    "guide.warning.title": "Warm Reminder",
    "guide.warning.rule1": "What situations cause commission invalidation?",
    "guide.warning.answer1": "Using software or other platforms to maliciously obtain commissions will result in all commissions being deducted and account suspension once verified.",
    "guide.warning.rule2": "Can I earn commission by inviting myself?",
    "guide.warning.answer2": "No. We conduct manual checks, and any verified cheating will result in all commissions being deducted, invitation qualifications revoked, and account clearance.",
    "invite.title": "Benefits are here | Invite friends and earn 4 huge prizes!",
    "invite.reward1.title": "Reward 1: Invite to Group, Easily Earn USD + Gift Cards",
    "invite.reward1.item1": "Get red packet rewards for every 10 successfully invited new members!",
    "invite.reward1.item2": "Also receive 1 USD gift card",
    "invite.reward1.item3": "The more you invite, the more rewards! Red packets sent instantly, gift cards redeemable now!",
    "invite.reward2.title": "Reward 2: Lucky Purchase, Earn Commission Easily",
    "invite.reward2.item1": "You earn commission whenever your friends participate in lucky purchase activities!",
    "invite.reward2.item2": "Unlimited commission, the more they buy, the more you earn!",
    "invite.reward3.title": "Reward 3: Gift Cards",
    "invite.reward3.item1": "You immediately earn commission when your friends buy any gift card!",
    "invite.reward3.item2": "Zero-cost sharing link, automatic tracking, super easy operation:",
    "invite.reward3.item3": "Send link → Friend orders → Wait for payment!",
    "invite.callToAction": "Hurry up and invite friends to join the group, bring all the benefits home! Let's play and earn together!",
    "share.title": "GoBuy Winning Share to Win 1 USD Gift Card",
    "share.subtitle": "Share Title",
    "share.content1": "Thanks to GoBuy Lucky Shopping for the good luck. One of our members made a small investment today, won prizes, and successfully withdrew! ✨",
    "share.content2": "Now it’s your turn! Simply share your winning experience to get a free 1 USD GoBuy gift card! Don’t miss out—simple, rewarding, and fun!",
    "share.inviteLink": "Attach your invitation link code:",
    "share.stepsTitle": "How to participate:",
    "share.step1": "Upload your code purchase/order screenshot in the lucky purchase area",
    "share.step2": "Upload the 'Congratulations, you won!' message screenshot",
    "share.step3": "Upload your withdrawal application and transaction success screenshot",
    "share.step4": "After completing the above, send your social media sharing screenshot to customer service for verification",
    "share.email": "Customer support email:",
    "share.footer": "May luck be with you—keep playing, keep winning! GoBuy—making shopping fun and rewarding every day!",
    "doubleBet.title": "Betting Miracle｜Simple 3 Steps, Reverse and Win Big Prizes!",
    "doubleBet.step1": "Round 1: Choose the $1 zone, buy $0.5, purchase 5 units, and stop once you win.",
    "doubleBet.step2": "If not won, Round 2: Choose the $3 zone, buy $1.5, purchase 15 units, and stop once you win.",
    "doubleBet.step3": "If still not won, Round 3: Choose the $8 zone, buy $4, purchase 40 units, congratulations on winning.",
    "doubleBet.step4": "After winning, you can cover the losses from the previous rounds and make a profit, then restart from Round 1.",
    "invite.reward4.title": "Reward 4: Limited Time Benefits | Exclusive Gifts for New Users",
    "invite.reward4.step1": "Free participation in 1 Lucky Purchase",
    "invite.reward4.step2": "Free activation of 1 Mystery Box Lottery",
    "invite.reward4.step3": "Complete specified tasks and earn an additional $1 cash reward",
    "reward.register.title": "Sign-up Reward",
    "reward.register.point1": "New users get one free Lucky Buy entry upon registering.",
    "reward.register.point2": "Join the group after sign-up to join the red packet event.",
    "reward.task.title": "Task Reward",
    "reward.task.point1": "Log in as a guest and open one blind box.",
    "reward.task.point2": "Complete the following Lucky Buy tasks, one per zone:",
    "reward.task.subtask1": "£1 zone: buy £0.5 once",
    "reward.task.subtask2": "£3 zone: buy £1.5 once",
    "reward.task.subtask3": "£8 zone: buy £4 once",
    "reward.task.point3": "Finish both tasks to receive a £1 activity reward!",
    "reward.share.title": "Share Reward",
    "reward.share.desc": "Je viens de gagner une boîte surprise et un tirage au sort sur GoBuy !",
    "reward.share.desc3": "J'ai eu de la chance juste après mon inscription – incroyable !",
    "reward.share.desc4": "✨Partage une capture d’écran de ta victoire pour recevoir 1 $ de récompense.",
    "reward.share.desc1": "Invite 10 friends and get $1 after they register. Invite 1,000 to earn $100 in rewards — no limit, the more you invite, the more you earn!",
    "reward.invite.title": "Invite Reward",
    "reward.invite.desc": "Successfully invite 10 friends and complete their registration.",
    "reward.share.desc2": "Complete the above tasks to claim your sharing and invitation rewards!",
    "reward.invite.desc1": "Complete the above tasks to claim your invitation event reward!",

    "account.bank": "Bank",
    "account.name": "Account Name",
    "bank.name": "Bank Name",
    "account.number": "Account Number",
    "account.ifsc": "IFSC Code",
    "account.type": "Account Type",
    "bank.upi.code": "UPI Code",
    "bank.upi": "UPI Scan",
    "save.img.save": "Long press the image above to save",
    "bank.pay.tip": "Tip: Please enter the correct INR amount during the transfer; otherwise, the system cannot automatically identify the payment.",
    "bank.upi.order": "UPI Transaction ID/Reference Number",
    "Please enter a upi order": "Please enter the UPI Transaction ID/Reference Number",

    "guide.title": "User Guide",
    "guide.section1.title": "Lucky Buy",
    "guide.section1.step1": "Each $0.1 = 1 entry",
    "guide.section1.step2": "System randomly draws → Win $1–$50,000",

    "guide.section2.title": "Blind Box",
    "guide.section2.step1": "Each $1 = 1 entry this round",
    "guide.section2.step2": "Win up to $3,000,000 jackpot",

    "guide.section3.title": "Gift Card",
    "guide.section3.step1": "$98 = $100 Gift Card",
    "guide.section3.step2": "System buyback → Earn $2 profit",

    "guide.tip.callToAction": "Join Now",

    "guide.Invitation.Reward": "Invitation Rewards",
    "reward.register.title": "Registration Reward",
    "reward.register.point1": "New users register → 🎟️ Get 1 Lucky Buy chance",
    "reward.register.point2": "✨ Automatically granted, no need to apply",

    "reward.recharge.title": "First Recharge Reward",
    "reward.recharge.point1": "New users' first recharge → 🎁 Get $2 reward",
    "reward.recharge.point2": "📩 Customer service email: gobuyusa888@gmail.com",
    "reward.task.point3": "Complete tasks to unlock more rewards",

    "reward.invite.title": "Invite Friends Reward",
    "reward.invite.point1": "Invite friends to recharge → 🎁 Get $1 reward",
    "reward.invite.point2": "No limit, the more invites, the more rewards!",
    "reward.invite.point3": "Automatically granted, no need to apply",

    "share.rewardTitle": "Sharing Reward",
    "share.rewardStep1": "Share your Lucky Buy / Blind Box / Gift Card winning screenshot to the community",
    "share.rewardStep2": "Share once = Reward $1",
    "share.rewardStep3": "Each user can claim only once",
    "share.email": "Please send email to gobuyusavip@gmail.com",

    "share.guestTitle": "Guest Task Reward",
    "share.guestStep1": "Complete the following 2 tasks:",
    "share.guestStep2": "1️⃣ Purchase 1 Lucky Buy",
    "share.guestStep3": "2️⃣ Purchase 3 Blind Boxes",
    "share.guestStep4": "⚠️ Each user can claim only once",
    "share.guestContact": "Customer Service Email: gobuyusa888@gmail.com",

    "share.teamTitle": "Team Reward",
    "share.teamStep1": "🔗 Users registered through your invitation link = your team members",
    "share.teamStep2": "🏆 Reward rules:",
    "share.teamStep3": "• Invite 10 active members → Reward $1",
    "share.teamStep4": "• Invite 1000 active members → Reward $100",
    "share.teamNote": "⚠️ Active members = users who recharge and complete at least one purchase (Gift Card / Blind Box / Lucky Buy).",
    "share.teamContact": "Customer Service Email: gobuyusa888@gmail.com",

    "guest.rewardTitle": "Guest Task Reward",
    "guest.intro": "Complete the following 2 tasks:",
    "guest.task1": "Purchase 1 Blind Box",
    "guest.task2": "Purchase 3 Lucky Draws",
    "guest.limit": "Each user can claim once only",

    "team.rewardTitle": "Team Reward",
    "team.ruleIntro": "Users registered through your invitation link = your team members",
    "team.ruleTitle": "Reward Rules:",
    "team.rule1": "Invite 10 active members → Reward $1",
    "team.rule2": "Invite 1000 active members → Reward $100",
    "team.note": "Active member = A user who registers, recharges, and makes at least one purchase (Gift Card / Mystery Box / Lucky Draw).",

    
    "reward.firstCharge.title": "First Deposit Reward",
    "reward.firstCharge.point1": "New users first deposit → 🎁 get $2 bonus",
}
export default en
